import { useState } from "react";
import { useTranslation } from "react-i18next";

import Modal from "@/components/Modal";
import RebrandButtonLink from "@/components/RebrandButtonLink";
import RebrandPrimaryButton from "@/components/RebrandPrimaryButton";
import Spacer from "@/components/Spacer";
import useGetColours from "@/helpers/getColours";
import { useUIStateStore } from "@/store/uiStateStore";

function DeleteRecordingModal({ isOpen, onClose, onConfirm }) {
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);

  const isTunecore = useUIStateStore(state => state.isTunecore);
  const { t } = useTranslation(["songs", "common"]);
  const { highlightColour } = useGetColours();

  const handleConfirm = () => {
    if (doNotShowAgain) {
      localStorage.setItem("showDeleteRecordingWarning", "false");
    }
    onClose();
    onConfirm();
  };

  return (
    <Modal smallModal openPortal={isOpen} closePortal={onClose}>
      <div
        className={`flex flex-col justify-between min-h-80 sm:min-h-48 ${
          isTunecore ? "text-white" : "text-black font-sentric"
        }`}
      >
        <div>
          <h2 className="text-lg">
            {t("songs:delete-recording-modal-header")}
          </h2>
          <Spacer thin />
          <p>{t("songs:delete-recording-modal-text")}</p>
        </div>

        <div>
          <input
            style={{
              accentColor: highlightColour,
            }}
            type="checkbox"
            className={`mr-3 lg:scale-125 ${
              isTunecore ? "text-tunecore-blue" : ""
            }`}
            id="doNotShowAgain"
            checked={doNotShowAgain}
            onChange={() => setDoNotShowAgain(!doNotShowAgain)}
          />
          <label htmlFor="doNotShowAgain">{t("common:dont-show-again")}</label>
        </div>
      </div>
      <Spacer thin />
      <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
        <RebrandButtonLink onClick={onClose}>
          {t("common:take-me-back-button")}
        </RebrandButtonLink>
        <RebrandPrimaryButton onClick={handleConfirm}>
          {t("songs:delete-work-confirm-button")}
        </RebrandPrimaryButton>
      </div>
    </Modal>
  );
}

export default DeleteRecordingModal;
